import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import { concat, compact, map } from "lodash";
import NavigationDrawer from "react-md/lib/NavigationDrawers";
import MenuButton from "react-md/lib/Menus/MenuButton";
import ListItem from "react-md/lib/Lists/ListItem";
import Avatar from "react-md/lib/Avatars";
import FontIcon from "react-md/lib/FontIcons";
import TextField from "react-md/lib/TextFields";

import AtollonLogo from "../assets/img/atollon-logo.png";
import AtollonToolbarTouchText from "../assets/img/atollon-toolbarTouchText.png";
import AtollonLogoBlack from "../assets/img/atollon-logo-black.png";
import AtollonLogoWhite from "../assets/img/atollon-logo-white.png";
import AtollonThumb from "../assets/img/atollon-thumb-white.png";

import { signOut } from "../actions/appActions";
import { setFilter, getRequestWithFilter } from "../actions/requestActions";

import { isAdmin } from "../utils";

import * as debug from "../Atollon/debug";
import {DebugElement} from "../Atollon/debug";
import * as enums from "../enums";
import {getAppVersion} from "../version";
import {searchBarAction} from "../actions/searchBarActions";
import {organizationPackageMapping_getRoutePathStringForForNavigationContainer} from "../Atollon/pages/OrganizationPackageMapping/shared";
import {} from "../Atollon/pages/OrganizationPackageMapping/OrganizationPackageMapping";
import {showSearchBarOnThisPage} from "../Atollon/Page";
import {TouchNumber} from "../AtollonTheme/ReactElements";

class MyAtollonUrl {
  static matchesLocation(relativeUrl) {
    return /^\/organizations.*$/.test(relativeUrl) || relativeUrl === "/";
  }
  static get() {
    return "/organizations";
  }
}

const getRequestText = ( state, text, side, status ) =>
{
    try {
      const count = state.request.requestCount[side][status] || 0;
      // {/*<div><span>Zamítnutý</span><TouchNumber text={getRequestCount('dismissed')}/></div>*/}
      return (
        <div><span>{text}</span><TouchNumber text={count}/></div>
      )
    }
    catch( _ )
    {
      return text;
    }
};

const Navigation = ({
  history,
  location,
  children,
  role,
  activateAccount,
  user,
  setFilter,
  filter,
  getRequestWithFilter,
  searchBarAction,
  state
}) => {
  if (activateAccount) {
    return <div>{children}</div>;
  }

  const admin = isAdmin(role);

  let navItems = [
    {
      key: "main",
      primaryText: "Hlavní panel",
      leftIcon: <FontIcon>home</FontIcon>,
      active: location.pathname === "/dashboard",
      onClick: () => history.push("/dashboard"),
      className: location.pathname === "/dashboard" ? "navigation-item-active" : null
    },
    {
      key: "wfme",
      primaryText: "Čeká na mě",
      leftIcon: <FontIcon>file_download</FontIcon>,
      rightIcon:
        location.pathname === "/requests-me" ? (
          <FontIcon>keyboard_arrow_up</FontIcon>
        ) : (
          <FontIcon>keyboard_arrow_down</FontIcon>
        ),
      active: location.pathname === "/requests-me",
      onClick: () => {
        if (location.pathname === "/requests-me") {
          setFilter(
            true,
            true,
            true,
            false,
            false,
            false,
            "",
            10,
            "CREATED",
            "ANY"
          );
          getRequestWithFilter("PENDING");
        } else {
          history.push("/requests-me");
        }
      },
      className:
        location.pathname === "/requests-me" ? "navigation-item-active" : null
    }
  ];

  if (location.pathname === "/requests-me") {
    navItems = concat(navItems, [
      {
        key: "wfmePending",
        primaryText: getRequestText( state, "Čekající", "PENDING", "initial" ),
        leftIcon: (
          <FontIcon  className={enums.requestStatusColor(enums.requestStatusText.INITIAL)}>fiber_manual_record</FontIcon>
        ),
        active:
          location.pathname === "/requests-me" &&
          filter.initial &&
          !filter.accepted &&
          !filter.resolving &&
          !filter.resolved &&
          !filter.closed &&
          !filter.dismissed,
        onClick: () => {
          setFilter(
            true,
            false,
            false,
            false,
            false,
            false,
            "",
            10,
            "CREATED",
            "ANY"
          );
          getRequestWithFilter("PENDING");
        },
        className:
          location.pathname === "/requests-me" ? "navigation-item-active" : null
      },
      {
        key: "wfmeAccepted",
        primaryText: getRequestText( state, "Přijat", "PENDING", "accepted" ),
        leftIcon: (
          <FontIcon  className={enums.requestStatusColor(enums.requestStatusText.ACCEPTED)}>fiber_manual_record</FontIcon>
        ),
        active:
          location.pathname === "/requests-me" &&
          !filter.initial &&
          filter.accepted &&
          !filter.resolving &&
          !filter.resolved &&
          !filter.closed &&
          !filter.dismissed,
        onClick: () => {
          setFilter(
            false,
            true,
            false,
            false,
            false,
            false,
            "",
            10,
            "CREATED",
            "ANY"
          );
          getRequestWithFilter("PENDING");
        },
        className:
          location.pathname === "/requests-me" ? "navigation-item-active" : null
      },
      {
        key: "wfmeResolving",
        primaryText: getRequestText( state, "Řešen", "PENDING", "resolving" ),
        leftIcon: (
          <FontIcon  className={enums.requestStatusColor(enums.requestStatusText.RESOLVING)}>fiber_manual_record</FontIcon>
        ),
        active:
          location.pathname === "/requests-me" &&
          !filter.initial &&
          !filter.accepted &&
          filter.resolving &&
          !filter.resolved &&
          !filter.closed &&
          !filter.dismissed,
        onClick: () => {
          setFilter(
            false,
            false,
            true,
            false,
            false,
            false,
            "",
            10,
            "CREATED",
            "ANY"
          );
          getRequestWithFilter("PENDING");
        },
        className:
          location.pathname === "/requests-me" ? "navigation-item-active" : null
      },
      {
        key: "wfmeResolved",
        primaryText: getRequestText( state, "Vyřešený", "PENDING", "resolved" ),
        leftIcon: (
          <FontIcon  className={enums.requestStatusColor(enums.requestStatusText.RESOLVED)}>fiber_manual_record</FontIcon>
        ),
        active:
          location.pathname === "/requests-me" &&
          !filter.initial &&
          !filter.accepted &&
          !filter.resolving &&
          filter.resolved &&
          !filter.closed &&
          !filter.dismissed,
        onClick: () => {
          setFilter(
            false,
            false,
            false,
            true,
            false,
            false,
            "",
            10,
            "CREATED",
            "ANY"
          );
          getRequestWithFilter("PENDING");
        },
        className:
          location.pathname === "/requests-me" ? "navigation-item-active" : null
      },
      {
        key: "wfmeClosed",
        primaryText: getRequestText( state, "Uzavřený", "PENDING", "closed" ),
        leftIcon: (
          <FontIcon  className={enums.requestStatusColor(enums.requestStatusText.CLOSED)}>fiber_manual_record</FontIcon>
        ),
        active:
          location.pathname === "/requests-me" &&
          !filter.initial &&
          !filter.accepted &&
          !filter.resolving &&
          !filter.resolved &&
          filter.closed &&
          !filter.dismissed,
        onClick: () => {
          setFilter(
            false,
            false,
            false,
            false,
            true,
            false,
            "",
            10,
            "CREATED",
            "ANY"
          );
          getRequestWithFilter("PENDING");
        },
        className:
          location.pathname === "/requests-me" ? "navigation-item-active" : null
      },
      {
        key: "wfmeDismissed",
        primaryText: getRequestText( state, "Zamítnutý", "PENDING", "dismissed" ),
        leftIcon: <FontIcon className={enums.requestStatusColor(enums.requestStatusText.DISMISSED)}>fiber_manual_record</FontIcon>,
        active:
          location.pathname === "/requests-me" &&
          !filter.initial &&
          !filter.accepted &&
          !filter.resolving &&
          !filter.resolved &&
          !filter.closed &&
          filter.dismissed,
        onClick: () => {
          setFilter(
            false,
            false,
            false,
            false,
            false,
            true,
            "",
            10,
            "CREATED",
            "ANY"
          );
          getRequestWithFilter("PENDING");
        },
        className:
          location.pathname === "/requests-me" ? "navigation-item-active" : null
      }
    ]);
  }

  navItems = concat(navItems, {
    key: "wfothers",
    primaryText: "Čeká na ostatní",
    leftIcon: <FontIcon>file_upload</FontIcon>,
    rightIcon:
      location.pathname === "/requests-other" ? (
        <FontIcon>keyboard_arrow_up</FontIcon>
      ) : (
        <FontIcon>keyboard_arrow_down</FontIcon>
      ),
    active: location.pathname === "/requests-other",
    onClick: () => {
      if (location.pathname === "/requests-other") {
        setFilter(
          true,
          true,
          true,
          false,
          false,
          false,
          "",
          10,
          "CREATED",
          "ANY"
        );
        getRequestWithFilter("NOT_PENDING");
      } else {
        history.push("/requests-other");
      }
    },
    className:
      location.pathname === "/requests-other" ? "navigation-item-active" : null
  });

  if (location.pathname === "/requests-other") {
    navItems = concat(navItems, [
      {
        key: "wfothersPending",
        primaryText: getRequestText( state, "Čekající", "NOT_PENDING", "initial" ),
        leftIcon: (
          <FontIcon className={enums.requestStatusColor(enums.requestStatusText.INITIAL)}>fiber_manual_record</FontIcon>
        ),
        active:
          location.pathname === "/requests-other" &&
          filter.initial &&
          !filter.accepted &&
          !filter.resolving &&
          !filter.resolved &&
          !filter.closed &&
          !filter.dismissed,
        onClick: () => {
          setFilter(
            true,
            false,
            false,
            false,
            false,
            false,
            "",
            10,
            "CREATED",
            "ANY"
          );
          getRequestWithFilter("NOT_PENDING");
        },
        className:
          location.pathname === "/requests-other"
            ? "navigation-item-active"
            : null
      },
      {
        key: "wfothersAccepted",
        primaryText: getRequestText( state, "Přijat", "NOT_PENDING", "accepted" ),
        leftIcon: (
          <FontIcon className={enums.requestStatusColor(enums.requestStatusText.ACCEPTED)}>fiber_manual_record</FontIcon>
        ),
        active:
          location.pathname === "/requests-other" &&
          !filter.initial &&
          filter.accepted &&
          !filter.resolving &&
          !filter.resolved &&
          !filter.closed &&
          !filter.dismissed,
        onClick: () => {
          setFilter(
            false,
            true,
            false,
            false,
            false,
            false,
            "",
            10,
            "CREATED",
            "ANY"
          );
          getRequestWithFilter("NOT_PENDING");
        },
        className:
          location.pathname === "/requests-other"
            ? "navigation-item-active"
            : null
      },
      {
        key: "wfothersResolving",
        primaryText: getRequestText( state, "Řešený", "NOT_PENDING", "resolving" ),
        leftIcon: (
          <FontIcon className={enums.requestStatusColor(enums.requestStatusText.RESOLVING)}>fiber_manual_record</FontIcon>
        ),
        active:
          location.pathname === "/requests-other" &&
          !filter.initial &&
          !filter.accepted &&
          filter.resolving &&
          !filter.resolved &&
          !filter.closed &&
          !filter.dismissed,
        onClick: () => {
          setFilter(
            false,
            false,
            true,
            false,
            false,
            false,
            "",
            10,
            "CREATED",
            "ANY"
          );
          getRequestWithFilter("NOT_PENDING");
        },
        className:
          location.pathname === "/requests-other"
            ? "navigation-item-active"
            : null
      },
      {
        key: "wfothersResolved",
        primaryText: getRequestText( state, "Vyřešený", "NOT_PENDING", "resolved" ),
        leftIcon: (
          <FontIcon className={enums.requestStatusColor(enums.requestStatusText.RESOLVED)}>fiber_manual_record</FontIcon>
        ),
        active:
          location.pathname === "/requests-other" &&
          !filter.initial &&
          !filter.accepted &&
          !filter.resolving &&
          filter.resolved &&
          !filter.closed &&
          !filter.dismissed,
        onClick: () => {
          setFilter(
            false,
            false,
            false,
            true,
            false,
            false,
            "",
            10,
            "CREATED",
            "ANY"
          );
          getRequestWithFilter("NOT_PENDING");
        },
        className:
          location.pathname === "/requests-other"
            ? "navigation-item-active"
            : null
      },
      {
        key: "wfothersClosed",
        primaryText: getRequestText( state, "Uzavřený", "NOT_PENDING", "closed" ),
        leftIcon: (
          <FontIcon className={enums.requestStatusColor(enums.requestStatusText.CLOSED)}>fiber_manual_record</FontIcon>
        ),
        active:
          location.pathname === "/requests-other" &&
          !filter.initial &&
          !filter.accepted &&
          !filter.resolving &&
          !filter.resolved &&
          filter.closed &&
          !filter.dismissed,
        onClick: () => {
          setFilter(
            false,
            false,
            false,
            false,
            true,
            false,
            "",
            10,
            "CREATED",
            "ANY"
          );
          getRequestWithFilter("NOT_PENDING");
        },
        className:
          location.pathname === "/requests-other"
            ? "navigation-item-active"
            : null
      },
      {
        key: "wfothersDismissed",
        primaryText: getRequestText( state, "Zamítnutý", "NOT_PENDING", "dismissed" ),
        leftIcon: <FontIcon className={enums.requestStatusColor(enums.requestStatusText.DISMISSED)}>fiber_manual_record</FontIcon>,
        active:
          location.pathname === "/requests-other" &&
          !filter.initial &&
          !filter.accepted &&
          !filter.resolving &&
          !filter.resolved &&
          !filter.closed &&
          filter.dismissed,
        onClick: () => {
          setFilter(
            false,
            false,
            false,
            false,
            false,
            true,
            "",
            10,
            "CREATED",
            "ANY"
          );
          getRequestWithFilter("NOT_PENDING");
        },
        className:
          location.pathname === "/requests-other"
            ? "navigation-item-active"
            : null
      }
    ]);
  }

  navItems = concat(navItems, [
    {
      key: "contacts",
      primaryText: "Kontakty",
      leftIcon: <FontIcon>supervisor_account</FontIcon>,
      active: /^\/contacts.*$/.test(location.pathname),
      onClick: () => history.push("/contacts"),
      className:
        location.pathname.match(/^\/contacts/) ? "navigation-item-active" : null
    },
    {
      key: "projects",
      primaryText: "Projekty",
      leftIcon: <FontIcon>collections_bookmark</FontIcon>,
      active: location.pathname === "/projects",
      onClick: () => history.push("/projects"),
      className:
        location.pathname === "/projects" ? "navigation-item-active" : null
    },
    {
      key: "organizations",
      primaryText: "Můj Atollon",
      leftIcon: <FontIcon>album</FontIcon>,
      active: MyAtollonUrl.matchesLocation(location.pathname),
      onClick: () => history.push(MyAtollonUrl.get()),
      className: MyAtollonUrl.matchesLocation(location.pathname) ? "navigation-item-active" : null
    }
  ]);

  // Navigation.js + NavigationContainer.js
  if( admin )
  {
      navItems.push(
          {
              key: "organizationPackageMapping",
              primaryText: "Balíčky",
              leftIcon: <FontIcon>dashboard</FontIcon>,
              active: /^\/organizationPackageMapping.*$/.test(location.pathname),
              onClick: () => history.push("/organizationPackageMapping"),
              className:
                  location.pathname === "/organizationPackageMapping" ? "navigation-item-active" : null
          }
      );

  }

  if(debug.debug_isEnabled())
  {
    navItems = concat( navItems, {
        key: "developer",
        primaryText: "Developer",
        leftIcon: <FontIcon>album</FontIcon>,
        active: /^\/developer.*$/.test(location.pathname),
        onClick: () => history.push("/developer"),
        className:
            location.pathname === "/developer" ? "navigation-item-active" : null
    });
  }

  const menuItems = compact([
    {
      primaryText: user ? (user.name ? user.name : user.identifier) : "Profil",
      onClick: () => history.push("/settings/profile")
    },
    admin
      ? { primaryText: "Hostitelé", onClick: () => history.push("/hosts") }
      : null,
    admin
      ? { primaryText: "Kategorie hostů", onClick: () => history.push("/hostCategories") }
      : null,
    admin
        ? { primaryText: "Kategorie serverů", onClick: () => history.push("/serverCategories") }
        : null,
    admin
      ? { primaryText: "Zdroje", onClick: () => history.push("/resources") }
      : null,
    admin
      ? { primaryText: "Balíčky", onClick: () => history.push(organizationPackageMapping_getRoutePathStringForForNavigationContainer()) }
      : null,
    { primaryText: "Odhlásit", onClick: () => signOut() },
      null
  ]);

    let searchBar = () => {
      if( showSearchBarOnThisPage( location ) )
      {
          return (
              <div className="searchBar-position">
                <div className="searchBar">
                    <TextField
                        id={"main-menu-search-bar"}
                        placeholder="Hledat"
                        className={"searchBar-text" /* search-input */}
                        onChange={value => {
                            searchBarAction({searchText:value});
                        }}
                        value={state.searchBar.searchText}
                    />
                    <FontIcon className="searchBar-icon search-icon">search</FontIcon>
                </div>
              </div>
          );
      }
      else
      {
          return null;
      }
    };

  return (
    <NavigationDrawer
      className="redesign-NavigationDrawer navigation "
      mobileDrawerType={NavigationDrawer.DrawerTypes.TEMPORARY}
      tabletDrawerType={NavigationDrawer.DrawerTypes.PERSISTENT_MINI}
      desktopDrawerType={NavigationDrawer.DrawerTypes.FULL_HEIGHT}
      toolbarTitle={
        <div className="NavigationDrawer-version-base">
          <div
            style={{backgroundImage: `url(${AtollonToolbarTouchText})`}}
            className="redesign-NavigationDrawer__toolbarTitle navigation-logo title"
            onClick={() => history.push("/")}
          />
            <div className="NavigationDrawer-version">{getAppVersion()}</div>
        </div>
      }
      drawerTitle={
        <img
          src={AtollonLogoWhite}
          width="200"
          alt="Touch"
          className="redesign-NavigationDrawer__drawerTitle__logo navigation-logo drawer"
          onClick={() => history.push("/")}
        />
      }
      navItems={navItems}
      toolbarActions={
        <MenuButton
          id="header-menu"
          className="redesign-NavigationDrawer__toolbarActions__MenuButton"
          icon
          position="tr"
          menuItems={map(menuItems, (item, key) => <ListItem {...{ key, ...item }} />)}
        >
            <Avatar
              src={AtollonThumb}
              role="presentation"
              suffix="black"
              className="redesign-NavigationDrawer__toolbarActions__MenuButton__Avatar navigation-avatar"
              />
        </MenuButton>
      }
    >

        {searchBar()}

      <div className={"Navigation-userName"}
           onClick={(e,value) => {
                setTimeout(()=>{history.push("/settings/profile");},0);
                e.preventDefault();
                e.stopPropagation();
           }}>{user ? (user.name ? user.name : user.identifier) : "Profil"}</div>
      <DebugElement text={"src/containers/Navigation.js"}/>
      <div className="TouchMainContainer  container">{children}</div>

        {/* /NavigationDrawer */}
    </NavigationDrawer>
  );
};

export default compose(
  withRouter,
  connect(
    (state) => {
      let { app: { role, activateAccount, user }, request: { filter } } = state;
      return {
          role,
          activateAccount,
          user,
          filter,
          state
        }
    },
    { setFilter, getRequestWithFilter, searchBarAction }
  )
  ,
  lifecycle({
      async componentWillMount() {
          let { getRequestWithFilter } = this.props;

          // preload all request, so You can show their counts next to their names in menu
          for( let status of ["PENDING", "NOT_PENDING"])
          {
              getRequestWithFilter( status, "", "", {initial:true, limit: 10, dateType: "CREATED", date: "ANY", textQuery: ""});
              getRequestWithFilter( status, "", "", {accepted:true, limit: 10, dateType: "CREATED", date: "ANY", textQuery: ""});
              getRequestWithFilter( status, "", "", {resolved:true, limit: 10, dateType: "CREATED", date: "ANY", textQuery: ""});
              getRequestWithFilter( status, "", "", {resolving:true, limit: 10, dateType: "CREATED", date: "ANY", textQuery: ""});
              getRequestWithFilter( status, "", "", {dismissed:true, limit: 10, dateType: "CREATED", date: "ANY", textQuery: ""});
              getRequestWithFilter( status, "", "", {closed:true, limit: 10, dateType: "CREATED", date: "ANY", textQuery: ""});
          }
      }
  })
)(Navigation);



// WEBPACK FOOTER //
// ./src/pages/Navigation.js